import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { PredefinedPhrase } from './PredefinedPhrasesList';
import PredefinedPhrasesForm from './PredefinedPhrasesForm';
import { Phrase, PhraseType } from '../../../../graphql/graphql';

interface Props extends BaseModalProps {
	defaultValue?: PredefinedPhrase;
	type: PhraseType;
	onSuccess: (data: Phrase) => void;
}

const PredefinedPhrasesFormModal: React.FC<Props> = props => {
	return (
		<BaseModal title='component.predefinedPhrasesForm.modalTitle' {...props}>
			<PredefinedPhrasesForm
				defaultValue={props.defaultValue}
				type={props.type}
				onSuccess={props.onSuccess}
			/>
		</BaseModal>
	);
};

export default PredefinedPhrasesFormModal;
